import { getPath, getInitialState } from "../../utils";

const initialState = {
  chatDepartments: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activeChatDepartment: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CHAT_DEPARTMENTS":
      return setChatDepartments(state, action);
    case "SET_ACTIVE_CHAT_DEPARTMENT":
      return setActiveChatDepartment(state, action);
    case "SET_CURRENT_PAGE_CHAT_DEPARTMENTS":
      return setCurrentPageChatDepartments(state, action);
    case "SET_ACTIVE_CHAT_DEPARTMENT_FILTERS":
      return setActiveChatDepartmentFilters(state, action);
    case "RESET_STATE_CHAT_DEPARTMENT":
      return resetState(state, action);
    default:
      return state;
  }
}

const setActiveChatDepartment = (state, action) => {
  return {
    ...state,
    activeChatDepartment: action.payload,
  };
};

const setChatDepartments = (state, action) => {
  return {
    ...state,
    chatDepartments: getPath(action.payload, "departments", []),
    prevPage: state.currentPage === 1 ? -1 : state.currentPage - 1,
    nextPage: getPath(action.payload, "hasNext", false)
      ? state.currentPage + 1
      : -1,
  };
};

const setCurrentPageChatDepartments = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setActiveChatDepartmentFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
